module.exports = __webpack_public_path__ + "static/media/iconFire.bf58af06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconFire.svg
// module id = 212
// module chunks = 0